import api from '@/api'

const store = {
  state: {
    dataMenuPrice: [],
    pagingMenuPrice: {
      page: 1,
      size: 20,
      total: 0
    },
    sortingMenuPrice: {
      byField: '',
      isDesc: false
    },
    filteringMenuPrice: {
      menuItemCode: null,
      priceType: null,
      price: null
    }
  },

  mutations: {
    SET_MENUPRICE: (state, payload) => {
      state.dataMenuPrice = payload
    },
    SET_PAGING_PAGE_MENUPRICE: (state, payload) => {
      state.pagingMenuPrice.page = payload
    },
    SET_PAGING_TOTAL_MENUPRICE: (state, payload) => {
      state.pagingMenuPrice.total = payload
    },
    SET_SORTING_MENUPRICE: (state, payload) => {
      state.sortingMenuPrice = payload
    },
    SET_FILTERING_MENUPRICE: (state, payload) => {
      state.filteringMenuPrice = payload
    }
  },

  getters: {
    GetAllMenuPrice: state => state.dataMenuPrice,
    PagingMenuPrice: state => state.pagingMenuPrice,
    SortingMenuPrice: state => state.sortingMenuPrice,
    FilteringMenuPrice: state => state.filteringMenuPrice
  },

  actions: {
    async UpdateSortingMenuPrice({ commit, dispatch }, payload) {
      commit('SET_SORTING_MENUPRICE', {
        byField: payload.byField,
        isDesc: payload.isDesc
      })
      dispatch('GetAllMenuPrice')
    },

    async UpdateFilteringMenuPrice({ commit, dispatch }, isResetField) {
      if (isResetField) {
        const emptyFilter = {
          cond: null,
          code: null,
          description: null
        }
        commit('SET_FILTERING_MENUPRICE', emptyFilter)
      }
      commit('SET_PAGING_PAGE_MENUPRICE', 1)
      dispatch('GetAllMenuPrice')
    },

    async GetAllMenuPrice({ commit, state }) {
      try {
        commit('SET_IS_FETCHING_DATA', true)
        const result = await api.GetAllMenuPrice(
          state.pagingMenuPrice,
          state.sortingMenuPrice,
          state.filteringMenuPrice
        )
        commit('SET_IS_FETCHING_DATA', false)
        commit('SET_PAGING_TOTAL_MENUPRICE', result.headers['data-length'])
        commit('SET_MENUPRICE', result.data.data)
        return result.data
      } catch (e) {
        commit('SET_IS_FETCHING_DATA', false)
        throw e
      }
    },

    async CreateMenuPrice({ dispatch }, payload) {
      try {
        const { data } = await api.CreateMenuPrice(payload)
        dispatch('GetAllMenuPrice')
        return data
      } catch (e) {
        return e.response
      }
    },

    async UpdateMenuPrice({ dispatch }, payload) {
      try {
        const { data } = await api.UpdateMenuPrice(payload.id, payload)
        dispatch('GetAllMenuPrice')
        return data
      } catch (e) {
        return e.response
      }
    },

    async DeleteMenuPrice({ dispatch }, id) {
      try {
        const { data } = await api.DeleteMenuPrice(id)
        dispatch('GetAllMenuPrice')
        return data
      } catch (e) {
        throw e
      }
    }
  }
}
export default store
